export const PLP_LABELS = 'PLP.plpTiles';
export const PRODUCT_DETAIL_LABELS = 'ProductDetailPage.PDP_Sub';
export const ACCOUNT_COMMON = 'account.common';
export const GLOBAL_LABELS = 'global';

export const lblPlpShopAll = 'lbl_plp_shop_all';
export const lblAddToBag = 'lbl_add_to_bag';
export const lblViewMore = 'lbl_view_more';
export const lblBiaMainTitle = 'lbl_bia_main_title';

const BuyItAgainBagPageLabels = {
  PLP: {
    plpTiles: {
      [lblAddToBag]: 'ADD TO BAG',
    },
  },
  ProductDetailPage: {
    PDP_Sub: {
      [lblViewMore]: 'View more',
    },
  },
  account: {
    common: {
      [lblBiaMainTitle]: 'Buy It Again',
    },
  },

  global: {
    CommonBrowseLabels: {
      [lblPlpShopAll]: 'SHOP ALL',
    },
  },
};
export default BuyItAgainBagPageLabels;
